/**
 * @packageDocumentation
 * @module      EmcRcFaults.ts
 * @description Creates a EmcRcFaults object with a map set to default values.
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
export default class EmcRcFaults {
    constructor() {
        this.fieldMap = new Map();
        this.fieldMap.set("RcDigital12Vdc", "0");
        this.fieldMap.set("RcDigital5VSense", "0");
        this.fieldMap.set("RcDigital3Vdc", "0");
        this.fieldMap.set("RcDigital3VdcAnalog", "0");
        this.fieldMap.set("RcDigital3VdcSW", "0");
        this.fieldMap.set("RcOsMonitorCpu", "0");
        this.fieldMap.set("RcOsMonitorRam", "0");
    }
}
//# sourceMappingURL=EmcRcFaults.js.map